import React, { createContext, useCallback, useContext, useState } from "react";
import ObjectPanelHost from "../components/travel/ObjectPanelHost";

// Single source of interaction for the Travel Knowledge Graph. Any component, anywhere, can call
// openObject({ type, key }) and the SAME panel opens. Panels stack so users can explore related
// objects (airline -> hub airport -> country -> ...) and step back.
const Ctx = createContext(null);

export function TravelObjectProvider({ children }) {
  const [stack, setStack] = useState([]);
  const openObject = useCallback((type, key, payload = null) => {
    if (!type || (!key && !payload)) return;
    setStack((s) => [...s, { type, key, payload }]);
  }, []);
  const back = useCallback(() => setStack((s) => s.slice(0, -1)), []);
  const close = useCallback(() => setStack([]), []);
  const current = stack[stack.length - 1] || null;
  return (
    <Ctx.Provider value={{ openObject, back, close, depth: stack.length }}>
      {children}
      {current && <ObjectPanelHost item={current} canBack={stack.length > 1} onBack={back} onClose={close} openObject={openObject} />}
    </Ctx.Provider>
  );
}

export function useTravelObject() {
  return useContext(Ctx) || { openObject: () => {}, back: () => {}, close: () => {}, depth: 0 };
}
